var _g, _g2, _path, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_1059)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_125_1059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.0271 16.2163H22.9731C19.2414 16.2163 16.2163 19.2414 16.2163 22.9731V77.0271C16.2163 80.7588 19.2414 83.7839 22.9731 83.7839H77.0271C80.7588 83.7839 83.7839 80.7588 83.7839 77.0271V22.9731C83.7839 19.2414 80.7588 16.2163 77.0271 16.2163Z",
    fill: "#68468E",
    fillOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_125_1059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5133 29.7295H36.4862C32.7546 29.7295 29.7295 32.7546 29.7295 36.4862V63.5133C29.7295 67.2449 32.7546 70.27 36.4862 70.27H63.5133C67.2449 70.27 70.27 67.2449 70.27 63.5133V36.4862C70.27 32.7546 67.2449 29.7295 63.5133 29.7295Z",
    fill: "#F5EBFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_125_1059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 37,
    width: 28,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5134 37.1621H36.4863V62.1684H63.5134V37.1621Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_125_1059)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_125_1059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.1002 48.2331L57.0417 40.6328L59.4302 42.6631L57.8379 44.0165L60.2264 46.0468L56.2455 49.4315L53.857 47.4013L50.4899 50.2633C51.1099 51.2773 51.2828 52.4463 50.9774 53.5591C50.6719 54.672 49.9083 55.6553 48.8245 56.3314C47.7406 57.0075 46.408 57.3318 45.0675 57.2457C43.7269 57.1596 42.4667 56.6688 41.5147 55.862C40.5621 55.0536 39.9818 53.982 39.8788 52.8413C39.7758 51.7005 40.157 50.5661 40.9533 49.6437C41.7496 48.7213 42.9082 48.0719 44.2194 47.813C45.5304 47.5542 46.9073 47.7033 48.1002 48.2331ZM47.0879 53.8308C47.303 53.6542 47.4746 53.4429 47.5926 53.2094C47.7106 52.9759 47.7728 52.7246 47.7754 52.4704C47.7779 52.2162 47.721 51.9642 47.6077 51.7288C47.4945 51.4936 47.3273 51.2798 47.1158 51.1001C46.9043 50.9203 46.6529 50.7782 46.376 50.6819C46.0993 50.5856 45.8027 50.5372 45.5036 50.5394C45.2046 50.5417 44.909 50.5944 44.6343 50.6948C44.3595 50.7951 44.111 50.941 43.9032 51.1238C43.4929 51.4849 43.2659 51.9685 43.271 52.4704C43.2762 52.9723 43.513 53.4525 43.9306 53.8075C44.3482 54.1624 44.9131 54.3638 45.5036 54.3681C46.0942 54.3725 46.6631 54.1795 47.0879 53.8308Z",
    fill: "#68468E"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_125_1059",
    x: -7.78369,
    y: -7.78369,
    width: 115.567,
    height: 115.567,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_125_1059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_125_1059",
    x: 25.7295,
    y: 25.7295,
    width: 48.5405,
    height: 48.5405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_125_1059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_125_1059",
    x: 35.8623,
    y: 40.6328,
    width: 28.3643,
    height: 24.6265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.407843 0 0 0 0 0.27451 0 0 0 0 0.556863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_125_1059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_125_1059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_1059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.afd0d47dd84d8656107ddc2fe96202b7.svg";
export { ForwardRef as ReactComponent };